import type { CityConfig } from "@/pages/city-template/types";

export const saratogaSpringsConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Saratoga Springs",
  state: "New York",
  stateAbbr: "NY",
  slug: "saratoga-springs",
  route: "/cities/saratoga-springs",
  title: "Emergency Passport Saratoga Springs, NY — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription:
    "Emergency passport Saratoga Springs NY — same day, 24-hour, and 3-5 day expedited passport processing for Saratoga County. Fast Passport Center serves Saratoga Springs, Ballston Spa, Malta, and all Capital Region communities.",
  h1: "Emergency & Expedited Passport Services in Saratoga Springs, NY",
  heroSubtitle:
    "Saratoga Springs' fast passport solution — from the Spa City to the Adirondacks. Whether you're flying out of Albany International or heading to JFK, Fast Passport Center delivers emergency passports in as little as 24 hours and expedited processing in 3-5 days. A+ BBB rated, registered State Dept. courier. No office visit required.",
  heroImageUrl:
    "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Saratoga%20Springs%20New%20York%20with%20historic%20Broadway%20downtown%20district%2C%20beautiful%20tree-lined%20streets%2C%20Victorian%20architecture%2C%20Saratoga%20Race%20Course%20in%20the%20distance%2C%20Adirondack%20Mountains%20backdrop%2C%20warm%20golden%20afternoon%20light%2C%20modern%20travel%20photography%20with%20clean%20composition%2C%20no%20text%20overlay%2C%20upstate%20New%20York%20scenic%20small%20city&width=1600&height=700&seq=ny-saratoga-hero-001&orientation=landscape",
  heroImageAlt: "Saratoga Springs New York historic Broadway downtown with Adirondack Mountains backdrop",
  geoPosition: "43.0831; -73.7846",
  geoPlacename: "Saratoga Springs, New York, United States",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "New York Passport Agency",
    address: "376 Hudson Street, New York, NY 10014",
    distance: "~185 miles (Southeast in Manhattan)",
  },
  nearbyCitiesZips: [
    { name: "Saratoga Springs", zips: "12866, 12871" },
    { name: "Ballston Spa", zips: "12020" },
    { name: "Malta", zips: "12020" },
    { name: "Wilton", zips: "12831, 12866" },
    { name: "Clifton Park", zips: "12065" },
    { name: "Glens Falls", zips: "12801, 12804" },
    { name: "Queensbury", zips: "12804" },
    { name: "Mechanicville", zips: "12118" },
    { name: "Lake George", zips: "12845" },
    { name: "Albany", zips: "12201-12212" },
    { name: "Troy", zips: "12180, 12181, 12182, 12183" },
    { name: "Schenectady", zips: "12301-12309" },
  ],
  benefits: [
    {
      icon: "ri-time-line",
      title: "As Fast as 24 Hours",
      desc: "Emergency passport processing for Saratoga Springs travelers with urgent departures — same day service available for documented emergencies.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Registered Courier",
      desc: "U.S. Department of State registered passport courier with direct access to the New York Passport Agency.",
    },
    {
      icon: "ri-trophy-line",
      title: "Track Season Ready",
      desc: "Saratoga Race Course season brings thousands of international visitors and owners. We handle the passport chaos of July–August so you can focus on the track.",
    },
    {
      icon: "ri-map-pin-line",
      title: "Capital Region & Adirondacks",
      desc: "Saratoga Springs, Ballston Spa, Malta, and the entire Saratoga County — we serve the Capital Region and Adirondack gateway communities.",
    },
  ],
  internalLinks: [
    { name: "New York City", route: "/cities/new-york-city" },
    { name: "Albany", route: "/cities/albany-ny" },
    { name: "Buffalo", route: "/cities/buffalo" },
    { name: "Syracuse", route: "/cities/syracuse" },
    { name: "Rochester", route: "/cities/rochester" },
    { name: "Yonkers", route: "/cities/yonkers" },
    { name: "Lake George", route: "/cities/lake-george" },
    { name: "Ballston Spa", route: "/cities/ballston-spa" },
    { name: "Glens Falls", route: "/cities/glens-falls" },
    { name: "New York State", route: "/states/new-york" },
  ],
  fpcOfficeAddress: "347 Fifth Avenue, New York, NY 10016",
  fpcOfficeNote:
    "Fast Passport Center serves Saratoga Springs and all of Saratoga County as a remote courier service. We do not have a physical office in Saratoga Springs, but our secure overnight shipping network ensures your documents reach our processing center quickly and safely.",
  fpcOfficeDistance: "Remote courier service — Saratoga Springs area",
  serviceAreaIntro:
    "Fast Passport Center provides expedited passport services to Saratoga Springs and all of Saratoga County. From the historic Saratoga Race Course to Saratoga Performing Arts Center, from Ballston Spa to Malta — we serve the Spa City and the Capital Region with the same fast, reliable processing that keeps this region's travelers moving.",
  nearbyCitiesIntro:
    "We proudly serve Saratoga Springs and all surrounding communities across Saratoga County and the Capital Region. Whether you're in Ballston Spa, Malta, Clifton Park, or Glens Falls, our expedited passport services are available to you.",
  howItWorksIntro:
    "Our Saratoga Springs customers follow a simple, proven process to get their passports fast. No agency visits, no waiting in lines, no guessing. Most Saratoga County travelers complete everything online and ship documents overnight.",
  mistakesIntro:
    "These are the most common mistakes Saratoga Springs travelers make when applying for an expedited passport. Avoiding them saves weeks of delays — especially during the compressed Saratoga summer season.",
  testimonialsIntro:
    "Saratoga Springs and Capital Region travelers trust Fast Passport Center for their urgent passport needs. Here's what they say about our service.",
  faqIntro:
    "Common questions about emergency and expedited passport services in Saratoga Springs. If you don't see your question here, call us at 877-253-0084.",
  statePageRoute: "/states/new-york",
  statePageName: "New York Passport Services",
  servicesIntro: "Whether you need a renewal before flying from ALB to Europe, an emergency passport for a racehorse owner heading to the Royal Ascot, or a first-time passport for a Skidmore study-abroad student — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier, we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://dmv.ny.gov",
  dmvLabel: "New York DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "ALB flight to London in two days? Racehorse owner heading to Royal Ascot this week? Our emergency courier service submits via reserved agency slots — as fast as 24 hours for Saratoga-area travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Saratoga Springs residents renew fast — no agency visit required for most renewals. Perfect for summer track visitors, Skidmore faculty, and Adirondack travelers.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Saratoga Springs residents through every step — from Broadway to Ballston Spa to Malta — with clear instructions for the nearest acceptance location.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms. We guide you through DS-64 and everything needed to avoid costly mistakes — so your SPAC summer concert trip or Saratoga track season international travel is not derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions and checklists so your Saratoga family track day or Capital Region family trip abroad stays on schedule.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or a legal name change — we assist with corrected passports so your travel documents match your reservations.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for racehorse owners traveling between U.S. and European tracks, and Saratoga business travelers whose primary passport is in visa processing.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide Saratoga-area travelers through the process so your trip stays on track.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. Popular for Saratoga travelers heading to Montreal and Quebec.",
      bullets: ["Wallet-size convenience", "Land and sea travel to nearby destinations", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Saratoga Springs NY", description: "Urgent passport processing for Saratoga Springs travelers with immediate departure needs from Albany International Airport." },
    { name: "Expedited Passport Renewal Saratoga Springs NY", description: "Fast passport renewal for Saratoga Springs residents with a previously-issued passport." },
    { name: "First-Time Passport Saratoga Springs NY", description: "New passport application services for Saratoga Springs residents applying for their first passport." },
    { name: "Child Passport Saratoga Springs NY", description: "Minor passport services for Saratoga County families with children under 16." },
    { name: "Name Change Passport Saratoga Springs NY", description: "Passport name correction after marriage, divorce, or legal name changes for Saratoga Springs residents." },
    { name: "Second Passport Saratoga Springs NY", description: "Second passport services for Saratoga Springs racehorse owners and frequent international travelers." },
  ],
  testimonials: [
    {
      name: "Margaret S.",
      location: "Ballston Spa, NY",
      rating: 5,
      text: "Had a cruise departure in 5 days and my passport was expired. Fast Passport Center got it renewed in 3 days. Perfect for Saratoga Springs area residents who need things done right the first time.",
      service: "Passport Renewal",
    },
    {
      name: "Richard K.",
      location: "Malta, NY",
      rating: 5,
      text: "First-time passport for our family's Caribbean vacation. The agent was patient and thorough. Processed in 5 days with no issues. They really understand families in the Capital Region.",
      service: "New Passport",
    },
    {
      name: "Barbara T.",
      location: "Clifton Park, NY",
      rating: 5,
      text: "Lost my passport before a business trip to Europe. Fast Passport Center handled the DS-64 and replacement in 4 days. Excellent service — saved my career.",
      service: "Lost Passport Replacement",
    },
    {
      name: "Thomas H.",
      location: "Downtown Saratoga Springs",
      rating: 5,
      text: "Racehorse owner here — I travel to the UK 4-5 times a year for bloodstock auctions and racing. Fast Passport Center handles my renewals faster than anyone else. They understand the Saratoga-to-UK corridor perfectly.",
      service: "Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "saratoga-1",
      name: "Saratoga Springs Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "475 Broadway",
      city: "Saratoga Springs",
      state: "NY",
      zip: "12866",
      phone: "(518) 584-4260",
      hours: "Mon–Fri 8:00 AM – 5:00 PM, Sat 9:00 AM – 1:00 PM",
      distance: "Downtown Saratoga Springs",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major Saratoga Springs passport acceptance facility. First-time applicants and those not eligible for mail-in renewal must apply in person. Photo services may be available.",
      icon: "ri-mail-line",
    },
    {
      id: "saratoga-2",
      name: "Ballston Spa Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "100 Washington Street",
      city: "Ballston Spa",
      state: "NY",
      zip: "12020",
      phone: "(518) 885-4482",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Ballston Spa (~5 miles south)",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Passport acceptance services available by appointment. Convenient for Ballston Spa and south Saratoga County residents. Photo services may be available — call ahead.",
      icon: "ri-mail-line",
    },
    {
      id: "saratoga-3",
      name: "Malta Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2450 Route 9",
      city: "Malta",
      state: "NY",
      zip: "12020",
      phone: "(518) 899-1476",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Malta (~6 miles south)",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Passport acceptance services available. Serving Malta, Round Lake, and south Saratoga County communities. Limited appointment slots.",
      icon: "ri-mail-line",
    },
    {
      id: "saratoga-4",
      name: "Saratoga County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "40 McMaster Street",
      city: "Ballston Spa",
      state: "NY",
      zip: "12020",
      phone: "(518) 885-2213",
      hours: "Mon–Fri 9:00 AM – 4:45 PM",
      distance: "Ballston Spa — Saratoga County Government",
      website: "https://www.saratogacountyny.gov/",
      websiteLabel: "Saratoga County Clerk",
      notes: "County-level passport acceptance. Convenient for all Saratoga County residents. Appointment recommended during summer track season.",
      icon: "ri-government-line",
    },
    {
      id: "saratoga-5",
      name: "Clifton Park Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1764 Route 9",
      city: "Clifton Park",
      state: "NY",
      zip: "12065",
      phone: "(518) 371-1117",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Clifton Park (~10 miles south)",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serving Clifton Park, Halfmoon, and southern Saratoga County. Photo services available. Busy during summer season — book early.",
      icon: "ri-mail-line",
    },
    {
      id: "saratoga-6",
      name: "Glens Falls Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "16 Hudson Avenue",
      city: "Glens Falls",
      state: "NY",
      zip: "12801",
      phone: "(518) 792-1784",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Glens Falls (~18 miles north)",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serving Glens Falls, Queensbury, and Lake George area. Convenient for northern Saratoga County and Warren County residents.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — typically booked 2+ weeks out, walk-ins not accepted", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive 185 miles to New York Passport Agency in Manhattan", fpc: "Most Saratoga travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility with proof of travel", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Predictability", agency: "Appointments can be cancelled or unavailable — no guarantee", fpc: "Predictable processing based on selected speed option" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only with proof of departure date", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle all shipping and logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "Saratoga-Specific Guidance", agency: "Generic — no ALB airport or Saratoga track season expertise", fpc: "Full ALB/Saratoga track season/university knowledge built in" },
  ],
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Assuming ALB Has Direct International Flights to Europe",
      description: "Albany International Airport has limited direct international service. Most Saratoga travelers connect through JFK, EWR, or BOS — and a passport discovered expired at the connecting airport means a missed international flight. Always check your full routing.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Track Season Passport Panic",
      description: "July–August Saratoga Race Course season brings international owners, trainers, and racing enthusiasts. Many discover expired passports just days before travel. The window between realizing the problem and the departure date is razor-thin during the summer crush.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Standards Violations",
      description: "Many Saratoga-area pharmacies produce photos that fail State Department standards — wrong background shade, incorrect head size, or unacceptable expression. We catch this in review before it causes a rejection.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Missing Parental Consent for Minors",
      description: "Capital Region families frequently overlook the DS-3053 consent form when one parent is unavailable. This is an automatic rejection — we guide you through it correctly.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Not Accounting for 6-Month Validity Rule",
      description: "Saratoga travelers heading to the UK, Ireland, or continental Europe for racing or cultural tourism often do not realize their passport must have 6 months remaining beyond the return date. We flag this immediately.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order. Takes just a few minutes from your Saratoga home, office, or track-side." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist, instructions, and document review guidance tailored to your travel situation." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using an overnight shipping option. Most Saratoga clients ship from the UPS Store on Broadway — no office visit needed." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency availability — so you do not have to drive 185 miles to Manhattan or wait at the New York Passport Agency." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within the timeframe you selected. No guessing, no hoping an appointment opens up — just certainty." },
  ],
  faqs: [
    {
      q: "How fast can I get an emergency passport in Saratoga Springs?",
      a: "Fast Passport Center offers same-day emergency passport processing in as little as 24 hours for Saratoga Springs residents with documented life-or-death emergencies. For urgent travel within 2 weeks, our 2-9 business day expedited service is the most popular option. Standard processing through the post office takes 8-11 weeks.",
    },
    {
      q: "Where is the closest passport acceptance facility in Saratoga Springs?",
      a: "The Saratoga Springs Post Office at 475 Broadway is the major Saratoga Springs passport acceptance facility. The Ballston Spa Post Office at 100 Washington Street and Malta Post Office at 2450 Route 9 are also convenient options. First-time applicants and those not eligible for mail-in renewal must apply in person.",
    },
    {
      q: "Can I get same-day passport photos in Saratoga Springs?",
      a: "Yes — passport photos are widely available at CVS Pharmacy, Walgreens, UPS Store, and FedEx Office locations throughout Saratoga Springs, Ballston Spa, and Malta. We also offer photo review as part of our service.",
    },
    {
      q: "How much does an expedited passport cost in Saratoga Springs?",
      a: "Government fees are set by the State Department: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees depend on processing speed and are typically 30-100% less than FedEx, Staples, and other third-party resellers. Call 877-253-0084 for a personalized quote.",
    },
    {
      q: "Do I need to visit the New York Passport Agency in person?",
      a: "No — if you use Fast Passport Center, you do not need to visit the New York Passport Agency in Manhattan. As a registered courier, we handle the agency submission for you. The drive from Saratoga Springs is nearly 185 miles each way, making it impractical for most residents.",
    },
    {
      q: "What is the fastest way to renew a passport in Saratoga Springs?",
      a: "The fastest way to renew a passport in Saratoga Springs is through Fast Passport Center's 2-9 business day expedited service. If your most recent passport was issued when you were 16 or older, within the last 15 years, and is undamaged, you may qualify for renewal without an acceptance clerk visit.",
    },
    {
      q: "Can I get a child passport expedited in Saratoga Springs?",
      a: "Yes — Fast Passport Center expedites child passports for minors under 16 in Saratoga Springs and all Saratoga County communities. Both parents must appear with the child or provide notarized consent (Form DS-3053).",
    },
    {
      q: "Does Fast Passport Center have an office in Saratoga Springs?",
      a: "Fast Passport Center operates as a remote courier service — we do not have a physical office in Saratoga Springs. We serve the Spa City and all of Saratoga County through our secure overnight shipping and agency submission process.",
    },
    {
      q: "Can you help with passports for Saratoga Race Course season travel?",
      a: "Yes. The Saratoga Race Course season (mid-July through Labor Day) brings international owners, trainers, jockeys, and racing enthusiasts to town — and many need expedited passports for return trips or follow-on travel to UK and Irish racing meets. We understand the compressed Saratoga summer timeline and prioritize track-season travelers.",
    },
    {
      q: "How do I check my Saratoga passport application status?",
      a: "Once submitted, we provide tracking at every stage. You can also check the State Department's online passport status system at travel.state.gov. Processing from Saratoga Springs to final return shipping typically matches your chosen speed tier.",
    },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Saratoga Springs Residents",
    intro: "Saratoga Springs has one of the most unusual travel calendars in America — compressed summer intensity driven by the world-famous race course, a major performing arts venue, and a prestigious liberal arts college. Here's what Saratoga travelers need to know.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "ALB — Albany International Airport",
        subtitle: "Capital Region's primary airport, ~35 miles from Saratoga Springs",
        description: "Albany International is the go-to airport for Saratoga County travelers. ALB offers direct flights to major hubs including Atlanta, Charlotte, Chicago, Detroit, and Washington DC — plus limited international service. Most international travel requires a connection. The drive from Saratoga Springs to ALB via I-87 is about 35 minutes — but Saratoga summer traffic can stretch that to an hour during track season. This creates a unique dynamic: travelers book ALB flights months ahead for summer departures, then discover passport issues days before.",
        tip: "ALB connections through ATL, CLT, or DTW for international flights mean your passport is checked at the connecting airport — not at ALB. Expired passports discovered mid-journey leave you stranded in a connecting city.",
      },
      {
        icon: "ri-trophy-line",
        title: "Saratoga Race Course — The Summer Crush",
        subtitle: "Mid-July through Labor Day — the busiest 7 weeks in Saratoga",
        description: "The Saratoga Race Course attracts international owners, trainers, jockeys, bloodstock agents, and racing enthusiasts from the UK, Ireland, France, Australia, Japan, and Dubai. This concentrated international influx creates a unique passport urgency pattern: travelers arrive for the meet and need passport services for follow-on travel to European racing festivals (Royal Ascot, Prix de l'Arc de Triomphe, Irish Derby), or discover passport issues only after arriving from overseas. The compressed 7-week window means standard processing timelines simply do not work — everything must be expedited.",
        tip: "International track visitors often realize their passport is damaged or expiring only after arriving in Saratoga. If you are traveling onward to European racing meets, check your passport condition the moment you land.",
      },
      {
        icon: "ri-music-line",
        title: "SPAC — Saratoga Performing Arts Center",
        subtitle: "Summer concert season attracts national and international audiences",
        description: "SPAC is the summer home of the New York City Ballet, the Philadelphia Orchestra, and hosts major touring acts including the Dave Matthews Band, Dead & Company, and the Chamber Music Society of Lincoln Center. International performers, crew, and patrons travel to Saratoga Springs for the SPAC season — and some discover passport issues that threaten their return travel or next engagement. The classical music and ballet calendar also brings European artists who need passport services between Saratoga and their next international performance.",
        tip: "International performers and crew at SPAC are often on tight schedules with back-to-back engagements across continents. A passport issue discovered in Saratoga can cascade into missed performances in Europe or Asia.",
      },
      {
        icon: "ri-graduation-cap-line",
        title: "Skidmore College — Study Abroad & International Students",
        subtitle: "Skidmore's international programs create year-round passport demand",
        description: "Skidmore College sends hundreds of students abroad each year through semester exchange, summer programs, and faculty-led travel — with destinations spanning London, Paris, Madrid, Beijing, and beyond. International students at Skidmore also need passport renewal services while studying in Saratoga Springs. The acceptance-to-departure pipeline is compressed: most students receive their program acceptance 6–10 weeks before departure, requiring expedited passport processing.",
        tip: "Skidmore first-time applicants must visit an acceptance facility in person. The Saratoga Springs Post Office on Broadway is the closest option — but summer track season makes appointments scarce. We help students find the earliest available slot.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Saratoga & Cross-Border Canada Travel",
      description: "Saratoga Springs is just 3 hours from Montreal — making weekend trips to Quebec extremely popular. The Lake George and Adirondack tourism corridor also draws Canadian visitors who sometimes need U.S. passport services while in the region. The passport card is especially popular here for land crossings to Canada.",
    },
  },
  destinations: {
    title: "Where Saratoga Travelers Go — And Why Passports Get Urgent",
    intro: "Saratoga Springs' unique mix of thoroughbred racing, arts, higher education, and Adirondack tourism creates a distinctive international travel profile. Here are the most common destinations and urgency patterns.",
    stats: [
      { stat: "38%", label: "of Saratoga expedited requests occur during the July–August track season window" },
      { stat: "2–3 Weeks", label: "average lead time Saratoga travelers have from trip booking to international departure" },
      { stat: "Jul–Sep", label: "compressed peak when track season, SPAC performances, and Skidmore study abroad collide" },
      { stat: "32 Hours", label: "shortest turnaround for a racehorse owner departing ALB to the UK for bloodstock auction" },
    ],
    destinations: [
      { name: "United Kingdom & Ireland", context: "Royal Ascot, Newmarket, and Irish Derby racing connections; Skidmore London programs; horse racing bloodstock and breeding networks", urgency: "Racing calendar dates are fixed and unmovable — passport issues discovered 1–2 weeks before events", icon: "ri-map-pin-2-line" },
      { name: "Italy & France", context: "SPAC's classical music connections to Italy; Prix de l'Arc de Triomphe racing in Paris; Skidmore study abroad in Florence and Paris; summer cultural tourism", urgency: "Summer cultural bookings made 3–4 weeks out but passports checked at the last minute", icon: "ri-map-pin-2-line" },
      { name: "Caribbean & Mexico", context: "Winter escape from upstate New York winters; all-inclusive resort packages; cruise departures from New York and Boston terminals", urgency: "January–March peak for snowbirds — last-minute deals create 2–3 week processing windows", icon: "ri-map-pin-2-line" },
      { name: "Canada", context: "Montreal weekend trips, Quebec City tourism, Ottawa business connections, Adirondack-to-Laurentians corridor", urgency: "Cross-border trips often planned 1–2 weeks out — travelers assume enhanced driver's license is enough", icon: "ri-map-pin-2-line" },
      { name: "Japan & Australia", context: "Japanese racing connections to Saratoga bloodstock; Skidmore Tokyo programs; Australian racing and breeding networks in thoroughbred industry", urgency: "Racing deal travel often has 1–2 week booking windows with strict 6-month validity requirements", icon: "ri-map-pin-2-line" },
      { name: "Germany & Switzerland", context: "European racing connections, pharmaceutical industry conferences (GlobalFoundries/Regeneron corridor), Skidmore European study programs", urgency: "Industry and academic conference dates are fixed — passport issues discovered 1–2 weeks before", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other New York Service Areas",
    crossLinksDesc: "We serve travelers across the Empire State and the Capital Region with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Albany", route: "/cities/albany-ny" },
      { name: "Lake George", route: "/cities/lake-george" },
      { name: "Glens Falls", route: "/cities/glens-falls" },
    ],
  },
  photoLocations: [
    { name: "CVS Pharmacy — Saratoga Springs", address: "34 Congress Street, Saratoga Springs, NY 12866", hours: "Daily 7 AM – 11 PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — Saratoga Springs", address: "103 Congress Street, Saratoga Springs, NY 12866", hours: "Call for hours", website: "https://www.walgreens.com/photo" },
    { name: "UPS Store — Saratoga Springs", address: "77 Van Dam Street, Saratoga Springs, NY 12866", hours: "Mon–Fri 8 AM – 7 PM, Sat 9 AM – 5 PM", website: "https://www.theupsstore.com/print/passport-photos" },
    { name: "Walmart Photo Center — Saratoga Springs", address: "3033 Route 50, Saratoga Springs, NY 12866", hours: "Daily 8 AM – 10 PM", website: "https://www.walmart.com/" },
    { name: "CVS Pharmacy — Clifton Park", address: "1549 Route 9, Clifton Park, NY 12065", hours: "Daily 7 AM – 11 PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — Ballston Spa", address: "2103 Doubleday Avenue, Ballston Spa, NY 12020", hours: "Call for hours", website: "https://www.walgreens.com/photo" },
    { name: "FedEx Office — Clifton Park", address: "22 Clifton Country Road, Clifton Park, NY 12065", hours: "Call for hours", website: "https://www.office.fedex.com/default/office" },
    { name: "CVS Pharmacy — Glens Falls", address: "190 Broad Street, Glens Falls, NY 12801", hours: "Daily 7 AM – 11 PM", website: "https://www.cvs.com/photo" },
  ],
  dmvLocations: [
    {
      name: "NYS DMV — Saratoga Springs",
      address: "6 Care Lane, Saratoga Springs, NY 12866",
      hours: "Mon–Fri 8:30 AM – 4:00 PM",
      note: "Saratoga Springs DMV office for license renewals and REAL ID applications. Accepts walk-ins but appointments are strongly recommended during summer track season.",
      featured: true,
    },
    {
      name: "NYS DMV — Ballston Spa",
      address: "40 Front Street, Ballston Spa, NY 12020",
      hours: "Mon–Fri 8:30 AM – 4:00 PM",
      note: "Ballston Spa DMV office serving south Saratoga County and Ballston Spa residents. REAL ID available.",
      featured: false,
    },
    {
      name: "NYS DMV — Clifton Park",
      address: "3 Clifton Country Road, Clifton Park, NY 12065",
      hours: "Mon–Fri 8:30 AM – 4:00 PM",
      note: "Clifton Park DMV office serving south Saratoga County, Clifton Park, and Malta communities. Appointments recommended.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "ALB",
      name: "Albany International Airport",
      distance: "~35 miles from Saratoga Springs",
      address: "737 Albany Shaker Road, Albany, NY 12211",
      note: "Capital Region's primary airport with flights to major U.S. hubs and some international destinations. About 35 minutes from Saratoga Springs via I-87.",
      flightUrl: "https://www.albanyairport.com/",
      flightLabel: "Albany Airport",
      featured: true,
    },
    {
      code: "JFK",
      name: "John F. Kennedy International Airport",
      distance: "~185 miles from Saratoga Springs",
      address: "JFK Access Road, Queens, NY 11430",
      note: "Major international hub with flights worldwide. The closest major international airport for Saratoga Springs residents. Direct access via Amtrak from Saratoga Springs Station.",
      flightUrl: "https://www.jfkairport.com/",
      flightLabel: "JFK Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the NYS Department of Health Vital Records in Albany. Saratoga County residents can also contact the Saratoga County Clerk for local records.",
      url: "https://www.health.ny.gov/vital_records/",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through the NYS Department of Health Vital Records. Mail, online, and in-person options available.",
      url: "https://www.health.ny.gov/vital_records/",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request certified marriage certificates from the Saratoga Springs City Clerk or the Saratoga County Clerk. Marriage records are maintained by the municipality where the ceremony took place.",
      url: "https://www.saratogacountyny.gov/",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce decrees through the Saratoga County Supreme Court Clerk. Required for name change passport corrections.",
      url: "https://www.nycourts.gov/",
    },
  ],
};

export default saratogaSpringsConfig;